import styles from "./PickupAndRefillLocation.module.css";
import { LocationCard } from "./LocationCard/LocationCard";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import { LocationConnector } from "./LocationCard/LocationConnector/LocationConnector";
import { useTranslation } from "@coworker/locales";

type PickupAndRefillLocationProps = {
  pickupLocation: string;
  refillLocation: string;
  hasSameLocation: boolean;
};

function PickupAndRefillLocation(props: PickupAndRefillLocationProps) {
  const { t } = useTranslation();

  return (
    <div className={styles["container"]}>
      <div className={styles["topWrapper"]}>
        <LocationConnector />
        <div className={styles["cardWrapper"]}>
          <LocationCard
            title={t("pickupLocation")}
            subtitle={t("homebaseString")}
            location={props.pickupLocation}
            type="pickup"
          />
          <LocationCard
            title={t("refillLocString")}
            location={props.refillLocation}
            type="refill"
          />
        </div>
      </div>
      {props.hasSameLocation && (
        <FixaInlineMessage
          variant="cautionary"
          title={t("pickupAndRefillLocationCannotBeSameString")}
        />
      )}
    </div>
  );
}

export default PickupAndRefillLocation;
